<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 32,
      height: 32,
      color: 'currentColor',
      viewBoxValue: `0 0 33 32`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <g id="phone">
      <path
        id="Icon"
        d="M11.9764 11.8043C12.9044 13.7371 14.1695 15.5487 15.7716 17.1508C17.3737 18.7529 19.1852 20.0179 21.118 20.9459C21.2843 21.0257 21.3674 21.0656 21.4726 21.0963C21.8464 21.2053 22.3054 21.127 22.622 20.9003C22.7111 20.8365 22.7873 20.7603 22.9397 20.6079C23.4058 20.1418 23.6389 19.9087 23.8733 19.7563C24.7571 19.1817 25.8966 19.1817 26.7804 19.7563C27.0148 19.9087 27.2479 20.1418 27.714 20.6079L27.9738 20.8677C28.6824 21.5763 29.0367 21.9306 29.2292 22.3111C29.6119 23.0679 29.6119 23.9616 29.2292 24.7183C29.0367 25.0988 28.6824 25.4531 27.9738 26.1617L27.7637 26.3719C27.0575 27.078 26.7044 27.4311 26.2244 27.7008C25.6917 28 24.8644 28.2152 24.2534 28.2134C23.7028 28.2117 23.3265 28.1049 22.5739 27.8913C18.5294 26.7433 14.7129 24.5774 11.5289 21.3934C8.34497 18.2094 6.17901 14.3929 5.03105 10.3484C4.81744 9.59582 4.71063 9.21953 4.709 8.66893C4.70718 8.05797 4.92233 7.23065 5.22155 6.69797C5.49122 6.21793 5.8443 5.86485 6.55046 5.15868L6.76064 4.9485C7.46923 4.23991 7.82353 3.88562 8.20404 3.69316C8.96078 3.3104 9.85447 3.3104 10.6112 3.69316C10.9917 3.88562 11.346 4.23991 12.0546 4.9485L12.3144 5.20833C12.7806 5.67447 13.0136 5.90754 13.166 6.14191C13.7407 7.02577 13.7407 8.16521 13.166 9.04906C13.0136 9.28343 12.7806 9.5165 12.3144 9.98264C12.162 10.1351 12.0858 10.2113 12.022 10.3004C11.7953 10.6169 11.7171 11.0759 11.826 11.4497C11.8567 11.5549 11.8966 11.6381 11.9764 11.8043Z"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </IconBase>
</template>

<style scoped lang="scss"></style>
